import AuthorProfile from "components/AuthorProfile";
// import ClassiComponent, { ClassiComponentProps } from "components/ClassiComBr";
import ScriptCode from "components/Scripts/Code";
import DivisorTabsButton from "components/Buttons/DivisorTabsButton";
import EditionFeatured, { EditionFeaturedProps } from "components/EditionFeatured";
import EditaisHeader from "components/Editais/Editais.index";
import EditaisFilters from "components/Editais/Editais.Filters";
import EditaisTeaser from "components/Editais/Editais.Teaser";
import FaleConosco from "components/FaleConosco";
import PagePrivacyPolicy from "components/Expediente/PrivacyPolicy.index";
import FooterComponent from "components/Footer/Footer.index";
import ScriptPiano from "components/Scripts/PianoOffer";
import PianoPerfil from "components/Scripts/PianoPerfil";
import SearchMoreBox from "components/SearchMore/SearchMore.index";
import SectionTitle, { SectionTitleProps } from "components/SectionTitle";
import SearchFilters from "components/SearchFilter/Search.Filter";
import SearchInputBox from "components/SearchInput/SearchInputBox.index";
import PageTeam from "components/Expediente/Team.index";
import PageTerms from "components/Expediente/Terms.index";
import VideoLive from "components/VideoLive";
import WhatsAppBanner, { WhatsAppBannerProps } from "components/WhatsAppBanner";
import NextLink from "next/link";
import React from "react";
import { WidgetTypes } from 'hooks/useGCJAnalytics';
import StoriesPopComponent from "components/StoriesPop/StoriesPopComponent.index";
import PageTermsTocantins from "components/Expediente/tocantins/Terms.index";

type BaseComponentVariants = "oneColumn" | "twoColumns";

type BaseComponentProps = {
  id: string;
  children?: any;
  className?: string;
  customProps?: {
    className?: string;
  };
  link?: string;
  name?: string;
  numberValue?: string;
  pageBlockId?: string;
  slotColor?: string;
  slotTemplate: string;
  slotTemplateCode?: string;
  slotTemplateColor?: string;
  slotTemplateIcon?: string;
  slotTemplateLayout?: string;
  title?: string;
  variant?: BaseComponentVariants;
};

const BaseComponent: React.FC<BaseComponentProps> = (props) => {
  const className = props.customProps?.className;
  const baseClassName = `BaseComponent ${props?.className || ""} ${className}`;
  if (props?.slotTemplateCode === "CbnPageTeam") {
    return <PageTeam site='cbn' />;
  }
  if (props?.slotTemplateCode === "CbngoPageTeam") {
    return <PageTeam site='cbngo' />;
  }
  if (props?.slotTemplateCode === "CbntoPageTeam") {
    return <PageTeam site='cbnto' />;
  }
  if (props?.slotTemplateCode === "DaquiPageTeam") {
    return <PageTeam site='daqui' />;
  }
  if (props?.slotTemplateCode === "PopularPageTeam") {
    return <PageTeam site='opopular' />;
  }
  if (props?.slotTemplateCode === "TocantinsPageTeam") {
    return <PageTeam site='tocantins' />;
  }

  if (props?.slotTemplateCode === "TempPagePrivacy") {
    return <PagePrivacyPolicy />;
  }
  if (props?.slotTemplateCode === "PageTermsTocantins") {
    return <PageTerms site='tocantins' />;
  }
  if (props?.slotTemplateCode === "PageTermsCbngo") {
    return <PageTerms site='cbngo' />;
  }
  if (props?.slotTemplateCode === "TemPageTerms") {
    return <PageTerms site='' />;
  }
  if (props.className === "TeaserEditais") {
    if (props?.slotTemplate !== "SearchLoadMore") {
      return (
        <EditaisTeaser
          {...props}
          customLink={NextLink}
          customLinkProps={{ legacyBehavior: true }}
        />
      );
    }
  }

  const handleSendClickEvent = (type: WidgetTypes) => {
    //[AVISO]: Script de analytics está sendo desabilitado para usar Chartbeat e Google Analytics para gerar os dados no BI,
    // quando confirmado a migração, remover.
    // enviarClickWidget(type);
  }

  const handleSendViewEvent = (type: WidgetTypes) => {
    //[AVISO]: Script de analytics está sendo desabilitado para usar Chartbeat e Google Analytics para gerar os dados no BI,
    // quando confirmado a migração, remover.
    // enviarViewWidget(type);
  }

  switch (props.slotTemplate) {
    case "AuthorMiniBio":
      return <AuthorProfile {...props} />;
    case "popMakeStories":
      return <StoriesPopComponent />;
      // FIXME rm classi
    // case "ClassiComBr":
      // const classiProps: ClassiComponentProps = {
      //   handleSendClickEvent,
      //   handleSendViewEvent,
      //   ...props
      // }
      // return <ClassiComponent {...classiProps} />;
    case "DivisorTabs":
      const divisorProps = {
        children: props.name,
        pageBlockId: props.pageBlockId,
        numberValue: props.numberValue,
        slotTemplateId: props.slotTemplateCode,
      };
      return <DivisorTabsButton {...divisorProps} />;
    case "DivisorSimples":
      const simpleTitleProps: SectionTitleProps = {
        isExpanded: false,
        isReadMore: false,
        titleColor: props.slotColor || "",
        titleIcon: props.slotTemplateIcon,
        titleLabel: props.title || "",
      };
      return <SectionTitle {...simpleTitleProps} />;
    case "DivisorVerMais":
      const sectionTitleReadMoreProps: SectionTitleProps = {
        titleLink: props?.link,
        isExpanded: true,
        isReadMore: true,
        titleIcon: props.slotTemplateIcon,
        titleLabel: props.title || "",
      };
      return <SectionTitle {...sectionTitleReadMoreProps} />;
    case "DivisorVejaMais":
      const sectionTitleSeeMoreProps: SectionTitleProps = {
        titleLink: props?.link,
        isExpanded: false,
        isSeeMore: true,
        titleIcon: props.slotTemplateIcon,
        titleLabel: props.title || "",
      };
      return <SectionTitle {...sectionTitleSeeMoreProps} />;
    case "DivisorVideos":
      const sectionTitleVideoProps: SectionTitleProps = {
        isExpanded: true,
        isReadMore: true,
        isVideoBox: true,
        titleIcon: props.slotTemplateIcon,
        titleLabel: props.title || "",
      };
      return <SectionTitle {...sectionTitleVideoProps} />;
    case "DivisorComLinha":
      const urlParams = new URLSearchParams(window.location.search)
      const searchTag = urlParams.get('tag') || ''
      const divisorTitle = searchTag ? `${props.title} ${searchTag}` : props.title || ''
      const sectionTitleProps: SectionTitleProps = {
        isExpanded: true,
        isReadMore: false,
        titleIcon: props.slotTemplateIcon,
        titleLabel: divisorTitle
      };
      return <SectionTitle {...sectionTitleProps} />;
    case "EditaisFilter":
      return <EditaisFilters {...props} />;
    case "EditaisHeader":
      return <EditaisHeader {...props} />;
    case "EditionFeatured":
      const editionProps: EditionFeaturedProps = {
        handleSendClickEvent,
        handleSendViewEvent,
        ...props
      }
      return <EditionFeatured {...editionProps} />;
    case "FaleConosco":
      return <FaleConosco {...props} />;
    case "Footer":
      return <FooterComponent />;
    case "SearchFilter":
      return <SearchFilters {...props} />;
    case "SearchInput":
      return <SearchInputBox {...props} buttonId='buscar-avancado-lupa' />;
    case "SearchLoadMore":
      return <SearchMoreBox {...props} />;
    case "ScriptCode":
      return <ScriptCode {...props} />;
    case "ScriptPiano":
      return <ScriptPiano {...props} />;
    case "ScriptPianoPerfil":
      return <PianoPerfil {...props} />;
    case "VideoLive":
      return <VideoLive {...props} />;
    case "WhatsApp":
      const whatsappBannerProps: WhatsAppBannerProps = {
        handleSendClickEvent,
        handleSendViewEvent,
        telNumber: props?.slotTemplateCode || '5562999952795'
      }
      return <WhatsAppBanner {...whatsappBannerProps} />;
      // FIXME rm classi
    // case "ClassiSearch":
      // return <ClassiSearch />;
    default:
      return (
        <>
          {/*<Block
            className={baseClassName}
            css={{
              align: ['row', 'between', 'top'],
              border: '1px solid rgba(0,0,0,0.1)',
              height: '200px',
              mb: '$3',
              width: '100%'
            }}
          >
            {props.children}
          </Block> */}
        </>
      );
  }
};

export default BaseComponent;
